import React, { useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const CustomRoutes = ({ isPrivate, permissao, exact, path, component }) => {
  const { isAllowed } = useContext(AuthContext);

  if (isPrivate && !localStorage.getItem("authToken")) {
    return <Redirect to="/" />;
  }

  if (permissao && !isAllowed(permissao)) {
    return <Redirect to="/app/403" />;
  }

  return <Route exact={exact} path={path} component={component} />;
};

export default CustomRoutes;
